/**
 * Meta Pixel tracking utility
 * Pixel ID: 1048353217809773 (optimizedhealthrx.com)
 */

export const META_PIXEL_ID = '1048353217809773';

const formatNumericValue = (value) => {
  if (value === null || value === undefined || value === '') return 0;
  const numValue =
    typeof value === 'string'
      ? parseFloat(value.replace(/,/g, ''))
      : parseFloat(value);
  return Number.isNaN(numValue) ? 0 : numValue;
};

/**
 * Fires InitiateCheckout once per checkout session (deduped via sessionStorage).
 */
export const fireInitiateCheckout = ({
  value,
  currency = 'USD',
  contentIds = [],
} = {}) => {
  if (typeof window === 'undefined' || !window.fbq) return;

  const dedupKey =
    contentIds.length > 0 ? contentIds.join(',') : 'default';
  const storageKey = `meta_initiate_checkout_${dedupKey}`;

  if (sessionStorage.getItem(storageKey)) return;

  const payload = { currency };
  const numericValue = formatNumericValue(value);
  if (numericValue > 0) {
    payload.value = numericValue;
  }

  window.fbq('track', 'InitiateCheckout', payload);
  sessionStorage.setItem(storageKey, '1');
};

/**
 * Fires Purchase once per order ID after successful payment confirmation.
 */
export const fireMetaPurchase = ({
  value,
  currency = 'USD',
  orderId,
} = {}) => {
  if (typeof window === 'undefined' || !window.fbq || !orderId) return;

  const storageKey = `meta_purchase_${orderId}`;
  if (sessionStorage.getItem(storageKey)) return;

  const numericValue = formatNumericValue(value);

  window.fbq('track', 'Purchase', {
    value: numericValue,
    currency,
  });

  sessionStorage.setItem(storageKey, '1');
};
